import { Address } from '../types/common';

export const formatAddress = (address: Address): string => {
  return `${address.street}, ${address.postalCode} ${address.city}, ${address.country}`;
};

export const generateQuotationNumber = (
  lastQuotationNumber?: string, 
  customerShortName?: string,
  allQuotations: any[] = [], // Array of all quotations to track company-specific numbering
  customerId?: string // Customer ID to track same-company sequences
): string => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0'); // 01-12
  
  // YC-year-month-XXX formátum
  const prefix = `YC-${year}-${month}-`;
  
  // Keresünk egy sorszámot az aktuális hónap ajánlatai között
  let sequenceNumber = 1;
  
  if (allQuotations.length > 0) {
    try {
      // Az összes ajánlati szám lekérése
      const quotationNumbers = allQuotations
        .filter(q => q.quotationNumber || q.number)
        .map(q => q.quotationNumber || q.number)
        .filter(Boolean);
      
      // Az aktuális hónap ajánlatainak szűrése
      const currentMonthQuotations = quotationNumbers.filter(num => {
        return num.startsWith(prefix);
      });
      
      // Legmagasabb sorszám meghatározása az aktuális hónapban
      if (currentMonthQuotations.length > 0) {
        const sequences = currentMonthQuotations.map(num => {
          const parts = num.split('-');
          if (parts.length >= 4) {
            // Az utolsó rész a sorszám (XXX)
            return parseInt(parts[3], 10);
          }
          return 0;
        }).filter(n => !isNaN(n));
        
        if (sequences.length > 0) {
          sequenceNumber = Math.max(...sequences) + 1;
        }
      }
    } catch (error) {
      console.error('Error calculating quotation number:', error);
    }
  }
  
  // Sorszám formázása 3 számjegyre (001, 002, stb.)
  const formattedSequence = sequenceNumber.toString().padStart(3, '0');
  
  // Végleges formátum: YC-2025-01-001
  return `${prefix}${formattedSequence}`;
};

// Currency formatter function
export const formatCurrency = (amount: number, currency: string = 'HUF'): string => {
  if (isNaN(amount)) return '0 ' + currency;
  
  return new Intl.NumberFormat('hu-HU', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

// Segédfüggvény a dokumentum dátumának formázásához
export const formatDocumentDate = (date: any): string => {
  try {
    if (!date) return '-';

    // Ha Timestamp objektum
    if (date && typeof date.toDate === 'function') {
      const d = date.toDate();
      return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}.`;
    }

    // Ha Date objektum
    if (date instanceof Date) {
      return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}.`;
    }

    // Ha szám (pl. timestamp)
    if (typeof date === 'number') {
      const d = new Date(date);
      return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}.`;
    }

    // Ha objektum seconds mezővel (Firebase Timestamp-szerű objektum)
    if (typeof date === 'object' && date !== null && 'seconds' in date) {
      const d = new Date(date.seconds * 1000);
      return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}.`;
    }

    // Utolsó próbálkozás - konvertálás számra
    const d = new Date(Number(date));
    return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}.`;
  } catch (error) {
    return '-';
  }
};